import { useNavigate } from 'react-router-dom';

/**
 * "Services Page" admin tab: unlike Service Pages there's only ever one
 * /services listing page (a singleton, not a list), so this tab is just an
 * index card linking to the dedicated full-viewport WYSIWYG route (see
 * ../ServicesPageEditor.jsx). The "Core Capabilities" cards shown on that
 * page come from the "Service Pages" tab, not from here.
 */
export default function ServicesPageTab() {
  const navigate = useNavigate();

  return (
    <div className="admin-panel">
      <div className="admin-panel__head">
        <div>
          <h2>Services Page</h2>
          <p className="admin-panel__desc">
            The fully inline-editable <strong>/services</strong> page (hero, AI-development pipeline,
            and the "Core Capabilities" cards). Each card comes from a page created in
            <strong> Service Pages</strong> — editing a card's title/description/features here also
            updates that page, and creating a new Service Page adds a new card automatically. Use
            <strong> Edit</strong> below for on-page WYSIWYG editing.
          </p>
        </div>
      </div>

      <div className="admin-list">
        <div className="admin-list-item">
          <div>
            <strong>Services</strong>
            <br />
            <a href="/services" target="_blank" rel="noopener noreferrer">
              /services
            </a>
          </div>
          <div className="admin-list-actions">
            <button
              type="button"
              className="admin-btn admin-btn--ghost admin-btn--sm"
              onClick={() => navigate('/admin/services-page/edit')}
            >
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
